/* eslint-disable */
import axios from "axios";
import { format } from "date-fns";
import "../utils/axios.interceptor";
import { urlCoreBack } from "../configs/config";

const epName = "v1/produccion/";
const nameItemsText = "Anteojos/Arreglos";
const nameItemText = "Anteojo/Arreglo";

const epNameAnteojo = "v1/anteojos/";
const epNameArreglo = "v1/arreglos/";
const epNameIniciaProduccion = "v1/inicia-produccion/";
const epNameBandejaActual = "v1/bandeja-actual/";
const epCambiaBandeja = "v1/cambia-bandeja/";
const epNameAreaActual = "v1/area-actual/";
const epCambiaArea = "v1/cambia-area/";
const epNameActualizaAnteojoArreglo = "v1/anteojo-arreglo-actualiza/";
const epNameEstadosAnteojoArreglo = "v1/anteojo-arreglo-estados/";
const epNameFinalizaAnteojoArreglo = "v1/finaliza/";
const epNameNoFinalizaAnteojoArreglo = "v1/no-finaliza/";

const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getAnteojosArreglos = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener " + nameItemsText;

  _params.id_area_actual_usuario = localStorage.getItem("id_area_deposito");

  if (params.areaProduccion) {
    _params.id_area_produccion = params.areaProduccion;
  }

  if (params.sucursalOrigen) {
    _params.id_area_punto_de_venta = params.sucursalOrigen;
  }

  if (params.anteojoArreglo) {
    _params.anteojo_arreglo = params.anteojoArreglo;
  }

  if (params.codigoAnteojoArreglo) {
    _params.gc_codigo_anteojo_arreglo = params.codigoAnteojoArreglo;
  }

  if (params.bandeja) {
    _params.bandeja = params.bandeja;
  }

  if (params.codigoGestionAtencion) {
    _params.gc_codigo = params.codigoGestionAtencion;
  }

  if (params.apellidoCliente) {
    _params.apellido = params.apellidoCliente;
  }

  if (params.nombreCliente) {
    _params.nombre = params.nombreCliente;
  }

  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
  }

  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
  }

  if (params.estadoActual) {
    _params.estado_actual = params.estadoActual;
  }

  if (params.fechaEstadoDesde) {
    _params.fecha_estado_desde = format(params.fechaEstadoDesde, "yyyy/MM/dd");
  }

  if (params.fechaEstadoHasta) {
    _params.fecha_estado_hasta = format(params.fechaEstadoHasta, "yyyy/MM/dd");
  }
  // if (params.usuario) {
  // 	_params.id_usuario = params.usuario;
  // }

  if ("rows" in params) {
    _params.rows = params.rows;
  }

  if ("first" in params) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getAnteojo = async (parIdAnteojo) => {
  let _errorMessage = `Se produjo un error al obtener el Anteojo`;

  let _params = {
    id: parIdAnteojo,
    tipo_respuesta: "original",
    estados: "n"
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameAnteojo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getArreglo = async (parIdArreglo) => {
  let _errorMessage = `Se produjo un error al obtener el Arreglo`;

  let _params = {
    id: parIdArreglo,
    tipo_respuesta: "original",
    estados: "n"
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameArreglo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const iniciaProduccion = async (parIniciaProduccion) => {
  let _errorMessage = `No fue posible iniciar la producción del anteojo/arreglo`;

  parIniciaProduccion.id_area = localStorage.getItem("id_area_deposito");
  parIniciaProduccion.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epNameIniciaProduccion}`,
      data: parIniciaProduccion,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Producción del anteojo/arreglo iniciada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-produccion-numero-bandeja-invalid") {
        response.ok = false;
        response.messageText =
          "El número de bandeja no es válido (>=" +
          response.data.error_data.bandeja_desde +
          " - <=" +
          response.data.error_data.bandeja_hasta +
          ")";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-produccion-bandeja-not-available") {
        response.ok = false;
        response.messageText = "La bandeja indicada no se encuentra disponible";
        response.messageSeverity = "error";
        return response;
      }

      if (
        response.data.code ===
        "err-produccion-cantidad-para-produccion-insuficiente-articulo-arm-asol"
      ) {
        response.ok = false;
        response.messageText =
          "La cantidad reservada para producción del armazón/anteojo de sol es insuficiente";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-produccion-cantidad-disponible-insuficiente-cristal-block") {
        response.ok = false;
        response.messageText = "La cantidad disponible del cristal/block es insuficiente";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getBandejaActual = async (parAnteojoArreglo, parIdGcAnteojoArreglo) => {
  let _errorMessage = `Se produjo un error al obtener la bandeja actual del anteojo/arreglo`;

  let _params = {
    anteojo_arreglo: parAnteojoArreglo,
    id_gc_anteojo_arreglo: parIdGcAnteojoArreglo,
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameBandejaActual}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const cambiaBandeja = async (parCambiaBandeja) => {
  let _errorMessage = `No fue posible asignar la bandeja al anteojo/arreglo`;

  parCambiaBandeja.id_area = localStorage.getItem("id_area_deposito");
  parCambiaBandeja.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epCambiaBandeja}`,
      data: parCambiaBandeja,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Nueva bandeja asignada al anteojo/arreglo";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-produccion-bandeja-not-available") {
        response.ok = false;
        response.messageText = "La bandeja indicada no se encuentra disponible";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getGestionAtencion = async (parIdGestionAtencion, parTipoQuery) => {
  let _errorMessage = "Se produjo un error al obtener la Gestión de Atencion";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/gestion-comercial/`,
      params: { id: parIdGestionAtencion, tipo_query: parTipoQuery },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getAreaActual = async (parAnteojoArreglo, parIdGcAnteojoArreglo) => {
  let _errorMessage = `Se produjo un error al obtener el area actual del anteojo/arreglo`;

  let _params = {
    anteojo_arreglo: parAnteojoArreglo,
    id_gc_anteojo_arreglo: parIdGcAnteojoArreglo,
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameAreaActual}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const cambiaArea = async (parCambiaArea) => {
  let _errorMessage = `No fue posible cambiar de area al anteojo/arreglo`;

  parCambiaArea.id_area = localStorage.getItem("id_area_deposito");
  parCambiaArea.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epCambiaArea}`,
      data: parCambiaArea,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Anteojo/arreglo cambiado de área";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getDatosAnteojoArreglo = async (parAnteojoArreglo, parIdGcAnteojoArreglo) => {
  let _errorMessage = `Se produjo un error al obtener los datos del anteojo/arreglo`;

  let _params = {
    anteojo_arreglo: parAnteojoArreglo,
    id_gc_anteojo_arreglo: parIdGcAnteojoArreglo,
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameActualizaAnteojoArreglo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const actualizaAnteojoArreglo = async (parActualizaAnteojoArreglo) => {
  let _errorMessage = `No fue posible actualizar el anteojo/arreglo`;

  parActualizaAnteojoArreglo.id_area = localStorage.getItem("id_area_deposito");
  parActualizaAnteojoArreglo.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epNameActualizaAnteojoArreglo}`,
      data: parActualizaAnteojoArreglo,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Anteojo/arreglo actualizado";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getEstadosAnteojoArreglo = async (parAnteojoArreglo, parIdGcAnteojoArreglo) => {
  let _errorMessage = `Se produjo un error al obtener los estados del anteojo/arreglo`;

  let _params = {
    anteojo_arreglo: parAnteojoArreglo,
    id_gc_anteojo_arreglo: parIdGcAnteojoArreglo,
  };

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameEstadosAnteojoArreglo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const finalizaAnteojoArreglo = async (parFinalizaAnteojoArreglo) => {
  let _errorMessage = `No fue posible finalizar el anteojo/arreglo`;

  parFinalizaAnteojoArreglo.id_area = localStorage.getItem("id_area_deposito");
  parFinalizaAnteojoArreglo.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epNameFinalizaAnteojoArreglo}`,
      data: parFinalizaAnteojoArreglo,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Anteojo/arreglo actualizado";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const noFinalizaAnteojoArreglo = async (parNoFinalizaAnteojoArreglo) => {
  let _errorMessage = `No fue posible finalizar el anteojo/arreglo`;

  parNoFinalizaAnteojoArreglo.id_area = localStorage.getItem("id_area_deposito");
  parNoFinalizaAnteojoArreglo.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epNameNoFinalizaAnteojoArreglo}`,
      data: parNoFinalizaAnteojoArreglo,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Anteojo/arreglo actualizado";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-produccion-bandeja-not-available") {
        response.ok = false;
        response.messageText = "La bandeja indicada no se encuentra disponible";
        response.messageSeverity = "error";
        return response;
      }
    }
    // err-produccion-bandeja-not-available
    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
